import { render, staticRenderFns } from "./PaymentSystems.vue?vue&type=template&id=31bd506e&scoped=true&"
import script from "./PaymentSystems.vue?vue&type=script&lang=js&"
export * from "./PaymentSystems.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSystems.vue?vue&type=style&index=0&id=31bd506e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd506e",
  null
  
)

export default component.exports